import type { ComponentType } from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import theme from 'styles/theme';

const RouterLinkComponent = RouterLink as ComponentType<LinkProps>;

const modalHeadingColor = '#000000';

export const Container = styled.div`
  background-color: white;
  border-radius: 10px;
  width: auto;
  height: auto;
  padding: 25px;
  overflow-x: hidden;
  font-family: 'Mangueira', sans-serif;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: ${modalHeadingColor};
`;

export const BackButton = styled.span`
  font-size: 1.25rem;
  color: ${modalHeadingColor};
  margin-right: 10px;
  margin-left: -3px;
  cursor: pointer;
`;

export const CloseIcon = styled.span`
  font-size: 22px;
  color: ${modalHeadingColor};
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
`;

export const CustomerInfoContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 25px;
  padding-bottom: 14px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 116px;
`;

export const InfoTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  height: 23px;
  color: ${modalHeadingColor};
`;

export const InfoText = styled.span`
  color: ${theme.colors.primaryText};
  font-family: 'Mangueira', sans-serif;
  font-size: 13px;
  height: 23px;

  @media (max-width: 460px) {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Hr = styled.hr`
  border-top: 1px dashed ${theme.colors.lightGray};
  margin: 0;
`;

export const DetailsContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 17px;
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;
  margin-top: 10px;
`;

export const SectionTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: bold;
  color: ${modalHeadingColor};
  font-size: 20px;
`;

export const Link = styled(RouterLinkComponent)`
  text-decoration: none !important;
  color: ${theme.colors.primaryText};
  font-size: 13px;
  height: 23px;
`;

export const InvoiceNumber = styled.span`
  color: ${theme.colors.primaryText};
  font-family: 'Mangueira', sans-serif;
  font-size: 13px;
  height: 23px;
  text-decoration: underline;
`;

export const TypeableLineContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .codeNotas {
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 992px) {
    .codeNotas {
      max-width: 180px;
    }
  }
`;

export const TypeableLineIcon = styled.i`
  font-size: 20px;
  font-weight: bold;
  margin-left: 5px;
  color: #000000;
`;

export const ToolTipText = styled.span``;

export const ToolTipButton = styled.a`
  cursor: pointer;
`;

export const AccessKeyInfo = styled(Info)`
  margin-top: 10px;
`;

export const AddressInfo = styled(Info)`
  margin-top: 8px;
`;
